import { actions } from './insurance_company/actions'
import { getters } from './insurance_company/getters'
import { state } from './insurance_company/state'
import { mutations } from './insurance_company/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}